const excludedCharsRegex = /[&;<>\\]/;

export const containsExcludedChars = (text: string) => excludedCharsRegex.test(text);
